import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import {
  Router,
  Route,
  Switch,
  BrowserRouter,
  Redirect,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/kapitalwise.scss?v1.4.0";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Login from "views/Login.js";
import { Provider } from "react-redux";
import store, { persistor } from "ReduxStore/store.js";
import { QueryClient, QueryClientProvider, } from 'react-query'
import Reset from "views/Reset.js";
import { ToastContainer, cssTransition } from "react-toastify";
import "animate.css";
import "react-toastify/dist/ReactToastify.min.css";
import ForgotPass from "views/ForgotPass.js";
import { PersistGate } from "redux-persist/integration/react";
import routes from "routes.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import PrivateRoute from "./Utils/PrivateRoute.js";
import { validateRoutesByRole } from "./Utils/Authorization";
import Guide from 'views/UserGuide/Guide'
import Signup from "views/Signup.js";
import AccountSusendedNotification from "views/Notifications/AccountSusendedNotification"
import OnboardPendingNotification from "views/Notifications/OnboardPendingNotification"
import axios from "axios";

const AdminLayout = (props) => {
  const [route, setRoute] = React.useState(routes);
  const backgroundColor = "blue";

  
  useEffect(() => {
    setRoute(validateRoutesByRole(routes))
  }, [])
  return (
    <div className="wrapper">
      <Guide />
      <Sidebar
        {...props}
        routes={route}
        backgroundColor={backgroundColor}
      />
      <div className="main-panel">
        <Switch>
          {route.map((prop, key) => {
            return (
              <PrivateRoute
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          })}
        </Switch>
      </div>
    </div>
  );
}

const hist = createBrowserHistory();
const queryClient = new QueryClient()

axios.interceptors.response.use(
  (response) => {
    return response
  }
  , (error) => {
    if (error?.response.data.type === "onboardPending") {
      hist.push({ pathname: "/verificationPending", state: { error: error } });
    } else if (error?.response.data.type === "suspended") {
      hist.push({ pathname: "/accountSuspended", state: { error: error } });
      localStorage.removeItem("token");
    }
    return Promise.reject(error)
  }
)

ReactDOM.render(
  <>
    <div id="cover" style={{ display: "none" }}></div>
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover
      transition={cssTransition({
        enter: "animate__animated animate__fadeInDown",
        exit: "animate__animated animate__fadeOutUp",
      })}
      limit={1}
    />
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Router history={hist}>


              <Switch>
                <Route
                  path="/admin"
                  render={(props) => <AdminLayout {...props} />}
                />
                <Route path="/forgotPassword" component={ForgotPass} />
                <Route path="/passwordReset" component={Reset} />
                <Route path="/signup" component={Signup} />
                <Route path="/accountSuspended" component={AccountSusendedNotification} />
                <Route path="/verificationPending" component={OnboardPendingNotification} />
                <Route
                  path="/login"
                  component={Login}
                />
                <Redirect from="/" to="/login" />
              </Switch>

            </Router>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </>,

  document.getElementById("root")
);
